import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import MyFinance from '../components/finance/MyFinance';
import PropertyDebtsToPay from '../components/finance/PropertyDebtsToPay';
import PropertyToPayDetail from '../components/finance/PropertyToPayDetail';
import CreatePropertyPayment from '../components/finance/CreatePropertyPayment';
import PropertyPays from '../components/finance/PropertyPays';
import { FinanceRouteProtected } from '../helpers/ProtectedRoute';
import PropertyPaymentDetail from '../components/finance/PropertyPaymentDetail';
import CreateAdvancePayment from '../components/finance/CreateAdvancePayment';
import Advance from '../components/finance/Advance';
import PropertyToPaysDetails from '../components/finance/PropertyToPaysDetails';
import ReportsProperty from '../components/finance/ReportsProperty';

const MyFinanceRoutes = ({ match: { url } }) =>
    <Switch>
        <Route path={`${url}/`} exact component={MyFinance} />
        <FinanceRouteProtected path={`${url}/topay`} exact component={PropertyDebtsToPay} />
        <FinanceRouteProtected path={`${url}/reports`} exact component={ReportsProperty} />
        <FinanceRouteProtected path={`${url}/topays`} exact component={PropertyToPaysDetails} />
        <FinanceRouteProtected path={`${url}/topay/:id`} exact component={PropertyToPayDetail} />
        <FinanceRouteProtected path={`${url}/topay/:id/payment`} exact component={CreatePropertyPayment} />
        <FinanceRouteProtected path={`${url}/pays`} exact component={PropertyPays} />
        <FinanceRouteProtected path={`${url}/pays/:propertyPayment`} exact component={PropertyPaymentDetail} />
        <FinanceRouteProtected path={`${url}/advance`} exact component={Advance} />
        <FinanceRouteProtected path={`${url}/advance/add`} exact component={CreateAdvancePayment} />
        <Redirect to="/errors/404" />
    </Switch>

MyFinanceRoutes.propTypes = { match: PropTypes.object.isRequired };

export default withRouter(MyFinanceRoutes);